import React from 'react';
import { Link } from 'react-router-dom';
import { Crown } from 'lucide-react';

const daysLeft = (iso) => Math.max(Math.ceil((new Date(iso) - Date.now()) / 86400000), 0);

export const UsageMeter = ({ usage }) => {
  if (!usage) return null;
  const { used, limit } = usage.prompts;
  const left = Math.max(limit - used, 0);
  const pct = limit ? Math.min((used / limit) * 100, 100) : 100;
  const isWriter = usage.plan === 'writer';
  const expired = usage.plan === 'expired';
  const label = isWriter ? 'Writer plan' : expired ? 'Trial ended' : `Free trial · ${daysLeft(usage.trial_ends_at)}d left`;
  const text = expired ? `Your ${usage.trial_days}-day trial has ended` : `${left} of ${limit} prompts left today`;
  return (
    <div className={`flex items-center gap-4 border rounded-xl px-4 py-3 ${expired ? 'bg-rose-50 border-rose-200' : 'bg-white/70 border-amber-100'}`} data-testid="usage-meter">
      <div className="flex-1">
        <div className="flex justify-between text-xs text-amber-900/80 mb-1">
          <span data-testid="usage-meter-text">{text}</span>
          <span className="uppercase tracking-wider font-medium" data-testid="usage-meter-plan">{label}</span>
        </div>
        <div className="h-1.5 bg-amber-100 rounded-full overflow-hidden">
          <div className={`h-full rounded-full transition-[width] ${left === 0 || expired ? 'bg-rose-400' : 'bg-amber-600'}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
      {!isWriter && (
        <Link to="/pricing" className="inline-flex items-center gap-1 text-xs font-semibold text-amber-900 hover:text-orange-700 whitespace-nowrap" data-testid="usage-upgrade-link">
          <Crown className="h-3.5 w-3.5" /> Upgrade
        </Link>
      )}
    </div>
  );
};
